module.exports = "<div class=\"ContentLoader\">\n  <div class=\"Loader\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/content_loader.html
// module id = 453
// module chunks = 24